import React, { Component } from 'react';
import {PARSE_SERVER_FILES_URI, SERVER_URL}  from '../../Constants';
import {ToastContainer, ToastStore} from 'react-toasts';
import ReactImageMagnify from 'react-image-magnify';
import LostItemFunctions from '../../LostItem/LostItemFunctions';
var QRCode = require('qrcode.react');
export default class FoundItemDetail extends Component {
    constructor(props) {
      super(props);
      this.state = 
        { 
            url: '../default-placeholder.png',
  
        };
  
      // calculate stats when new rows loaded, i.e. onModelUpdated
      this.props.api.addEventListener(
        'rowSelected',
        this.updateSelectedItem.bind(this)
      );
     
  
    }
    updateSelectedItem() {


        let selectedRows=  this.props.api.getSelectedRows();
        
        if (selectedRows.length===1){
         //   console.log( selectedRows[0]);
            let foundItem = selectedRows[0];
            this.setState({
                shortDescription: foundItem.ShortDescription,
                longDescription:foundItem.LongDescription,
                foundByName: foundItem.foundByName,
                foundDate: foundItem.foundDate,
                locationName: foundItem.locationName,
                releaseDate:foundItem.releaseDate,
                itemNumber:foundItem.itemNumber,
                storageLocation:foundItem.storageLocation,
                keywords:foundItem.keywords,
                itemStateDesc:foundItem.itemStateDesc,
                age:foundItem.age,
                foundByEmployeeId:foundItem.foundByEmployeeId,
                barcode:foundItem.barcode,
                id:foundItem._id,
                donateDisposeDate:foundItem.donateDisposeDate,
                donateDisposeNote:foundItem.donateDisposeNote,

                url: (selectedRows[0].Picture1)?(PARSE_SERVER_FILES_URI + selectedRows[0].Picture1) : '../default-placeholder.png',
               
            })
        }else{
            this.setState({
                shortDescription: '',
                
                url:  '',
            })
        }
      
    
      
        /* this.props.api.forEachNode((rowNode) => {
          const data = rowNode.data;
    
        });
    
        */
    }

    renderSelectRow(){
        return (
            <div  className='container' style={{backgroundColor:'white'}}>
                    <br/>
                <div className='col text-primary text-center'><h5>Select Row to View Details</h5></div>

            </div>
        )
    }

    navigateToItem=()=>{
        this.props.history.push('/LostItem/' + this.state.id);
    }

    openfoundItem=()=>{
        window.open('./lostItem/' + this.state.id)
    }
    render() {
  

        return (
          <div  className='container' style={{backgroundColor:'white', width:'300px'}}>
            <br/>
            <div className='col text-primary text-center'><h5>Details</h5></div>
                <br/> 
                <div className='row'>
                 <div className='col text-center'><span style={itemNumberStyle} >{this.state.itemNumber}</span></div>
              </div>
              <div className='row'>
                <div className='col text-center'>
                    <button className='btn btn-link' onClick={this.openfoundItem}>Open</button>
            
                </div>
             </div>    
                <br/>
                <div className='row'>      
                    <div className='col'>
                    <ReactImageMagnify  style={{maxWidth:250, maxHeight:250}} enlargedImagePosition='over' {...{
                                        smallImage: {
                                            alt: this.state.shortDescription,
                                            isFluidWidth: false,
                                            src: this.state.url,
                                            width: 250,
                                            height: 250,
                                        },
                                        largeImage: {
                                            src: this.state.url,
                                            width: 1200,
                                            height: 1800
                                        },
                                        isHintEnabled: true,
                                        shouldHideHintAfterFirstActivation: false
                                    }} />
                    </div>
                </div>
                <br/>
               
              <div className='row'>
                 <div className='col'><span style={itemValue} className='text-primary'>{this.state.shortDescription}</span></div>
              </div>
              <div className='row'>
                <div className='col'><span style={labelStyle} className='text-primary'>{this.state.longDescription}</span></div>
              </div>
              <br/>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Found Near:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.locationName}</span></div>
              </div>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Found On:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{LostItemFunctions.formatDate(this.state.foundDate)}</span></div>
              </div>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Found By:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.foundByName}</span></div>
              </div>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Employee ID:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.foundByEmployeeId}</span></div>
              </div>
                <div className='row'>      
                    <div className='col text-center'  style={{backgroundColor:'white'}}/>
                           
                 </div>

              <br/>
              <hr/>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Release On:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{LostItemFunctions.formatDate(this.state.releaseDate)}</span></div>
              </div>
              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Storage:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.storageLocation}</span></div>
              </div>
              <div className='row'>
                <div className='col-5'><span style={labelStyle} className='text-primary'>Status:</span></div>
                <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.itemStateDesc}</span></div>
              </div>    
              <div className='row'>
                <div className='col-5'><span style={labelStyle} className='text-primary'>Age:</span></div>
                <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.age}</span></div>
              </div>   
            <br/>
            <div className='row'>
                <div className='col-5'><span style={labelStyle} className='text-primary'>barcode:</span></div>
                <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.barcode}</span></div>
              </div>  

              <br/>

              <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Keywords:</span></div>
              </div>      
              <div className='row'>
              
                  <div className='col-12'><span style={keywordStyle} className='text-primary'>{this.state.keywords}</span></div>
              </div>      
              <hr/>
              <div className='row'>
                  <div className='col'><span style={labelStyle} className='text-primary'><h6>Disposition Detail</h6></span></div>
                
              </div>

             <div className='row'>
                  <div className='col-5'><span style={labelStyle} className='text-primary'>Disp. Dt.:</span></div>
                  <div className='col-7'><span style={itemValue} className='text-primary'>{LostItemFunctions.formatDate(this.state.donateDisposeDate)}</span></div>
              </div>
             <div className='row'>
                <div className='col-5'><span style={labelStyle} className='text-primary'>Disp. Note:</span></div>
                <div className='col-7'><span style={itemValue} className='text-primary'>{this.state.donateDisposeNote}</span></div>
              </div>  
             

              <br/>  <br/>

              <div className='row'>
                <div className='col text-center'>
                     {(this.state.id)?  (<QRCode value={SERVER_URL + '/Lostitem/'+ this.state.id} style={{width:75,height:75}} /> ): null }  
            
                </div>
             </div>  
            
          <br/>
       


                      <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
          </div>
        );
      }
}

const labelStyle ={
    fontSize:'12px',
    color:'black',

}
const itemNumberStyle ={
    fontSize:'16px',
    color:'#1480BA',
    fontWeight:'bold'
}

const itemValue ={
    fontSize:'12px',
    color:'black',
    fontWeight:'bold'
}
const keywordStyle ={
    fontSize:'11px',
    color:'gray',
    display:'inline-block', 
    textOverflow:'ellipsis',
    overflow:'hidden', 
    width:'100%'
    
}
